import React from 'react'
import { CheckCircleRounded } from '@mui/icons-material'
import { Button, Box } from '@mui/material'
import { parseISO, format } from 'date-fns'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'

import { isSunday, isSaturday, isToday, isPast } from 'date-fns'
import './DailyAvailability.css'

const DailyAvailability = ({ date, doctors, handleChange }) => {
  const d: Date = parseISO(date)
  const weekEnd: boolean = isSunday(d) || isSaturday(d)
  const isPastDay: boolean = isPast(d)
  const isCurrentDay: boolean = isToday(d)
  const isDisable = isPastDay && !isCurrentDay
  // const dayName: string = days[d.getDay()]
  const dayName: string = format(d, 'EEEE')

  return (
    <Box className="day">
      <Box className="weekDay">{dayName}</Box>
      <Box
        className={`${weekEnd ? 'WeekendDoctor' : 'availableDoctors'} ${isCurrentDay && 'TodayDoctor'} doctorsColumn`}
      >
        <Box className="date">{date.split('-')[2]}</Box>
        <hr></hr>
        <ul>
          {doctors.available.map((doctor, idx: number) => (
            <li key={idx}>
              <Box className="Doctor_list">
                {isDisable ? (
                  <CheckCircleRounded className="disabled_circle_icon" />
                ) : (
                  <CheckCircleRounded className="available_circle_icon" />
                )}
                <Button
                  sx={{
                    textTransform: 'none',
                    padding: '0',
                    fontSize: 14,
                    color: '#333',
                    fontWeight: 400,
                    maxWidth: '150px',
                    whiteSpace: 'normal',
                  }}
                  onClick={(e) => handleChange(e, doctor)}
                >{`${doctor.first_name}, ${doctor.last_name} `}</Button>
              </Box>
            </li>
          ))}
          {doctors.unavailable.map((doctor, idx: number) => (
            <li key={idx}>
              <Box className="Doctor_list">
                {isDisable ? (
                  <RemoveCircleIcon className="disabled_circle_icon" />
                ) : (
                  <RemoveCircleIcon className="unavailable_circle_icon" />
                )}

                <Button
                  sx={{
                    textTransform: 'none',
                    padding: '0',
                    fontSize: 14,
                    color: '#333',
                    fontWeight: 400,
                    maxWidth: '150px',
                    whiteSpace: 'normal',
                  }}
                  onClick={(e) => handleChange(e, doctor)}
                >{`${doctor.first_name}, ${doctor.last_name} `}</Button>
              </Box>
            </li>
          ))}
        </ul>
      </Box>
    </Box>
  )
}

export default DailyAvailability
